import { getSmsManualSetupPhoneCode } from '../../utils/storage-utils';
import SmsSentInfo from '../common/SmsSentInfo';

export interface SmsSentInstructionsProps {
  oktaComponent: JQuery<HTMLElement>;
}
export default function SmsSentInstructions({ oktaComponent }: Readonly<SmsSentInstructionsProps>) {
  const phoneCode = getSmsManualSetupPhoneCode();
  const unformattedPhoneNumber = oktaComponent.find('.strong').text();
  let formattedPhoneNumber: string = unformattedPhoneNumber;
  if (phoneCode) {
    const countryCodeWithPlus = `+${phoneCode}`;
    formattedPhoneNumber = `${countryCodeWithPlus}-${unformattedPhoneNumber.split(countryCodeWithPlus)[1]}`;
  }
  return <SmsSentInfo formattedPhoneNumber={formattedPhoneNumber} />;
}
